import { createAsyncThunk } from '@reduxjs/toolkit';
import commonSearchApi from '~/apis/commonSearch';
import { GET_COMMON_SEARCH } from '~/utils/constants/actionType';
import { IParamsGetCommonSearch } from '~/utils/interface/commonField';

export const handleGetCommonSearch = createAsyncThunk<any, IParamsGetCommonSearch>(
  GET_COMMON_SEARCH,
  async (params: IParamsGetCommonSearch, { rejectWithValue }) => {
    try {
      const res = await commonSearchApi.getCommonSearch(params);

      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
